<template>
  <div class="content">
      <el-tabs ref="tabs" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :label="item.poolName+'(' + item.type + ')'" :name="item.id" :key="index" v-for="(item,index) in pondList">
          <SinglePondDetail v-if="item.poolType === '1'" :poolId="item.id"></SinglePondDetail>
          <TotalPondDetail v-if="item.poolType === '2'" :poolId="item.id"></TotalPondDetail>
          <PackagePondDetail v-if="item.poolType === '3'" :poolId="item.id"></PackagePondDetail>
          <PaymentPondDetail v-if="item.poolType === '5'" :poolId="item.id"></PaymentPondDetail>
        </el-tab-pane>
      </el-tabs>
  </div>
</template>
<script>
import {poolGetFlowPoolList} from "@/api/api.js"; 
import PackagePondDetail from "./type/PackagePondDetail.vue";
import PaymentPondDetail from "./type/PaymentPondDetail.vue";
import SinglePondDetail from "./type/SinglePondDetail.vue";
import TotalPondDetail from "./type/TotalPondDetail.vue";
export default {
  name:'pondDetails',
  components: { 
    PackagePondDetail, 
    PaymentPondDetail,
    SinglePondDetail,
    TotalPondDetail
  },
  data() {
    return{
      userId:undefined,
      poolId:undefined,
      pondList:[],
      activeName:'0',
    }
  },
  watch:{
    $route: {
      handler: function(to, from){
        if(to.name == 'pondDetails'){
          this.initParams()
        }
      },
      immediate:true
    }
  },
  methods: {
    // tab切换初始化获取数据
    async initData(){
      let userId = this.userId
      poolGetFlowPoolList({userId}).then(res=>{
        this.pondList = res.data.data;
      })
    },
    initParams(){
      let params = this.$route.params;
      if(params && params.userId){
        sessionStorage.setItem("paramsData", JSON.stringify(this.$route.params));
      }else{
        params = JSON.parse(sessionStorage.getItem("paramsData"));
      }
      this.userId = params.userId;
      this.poolId = params.poolId;
      this.initData();
      //延迟切换选项
      setTimeout(()=>{
        this.activeName = this.poolId
      }, 500)
      
    },
    // tab切换
    handleClick(tab){
      this.poolId = tab.name;
      //切换的时候修改参数值
      let params = {
        poolId : this.poolId,
        userId : this.userId
      }
      sessionStorage.setItem("paramsData", JSON.stringify(params));
    },

  },
  created() {
    this.initParams()
  },
};
</script>
<style scoped lang="less">
.box-card{
  margin-bottom: 4px;
}
</style>


